'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.4.3@rc-switch/lib/index.js
 ** module id = 380
 ** module chunks = 0 1
 **/